enum Museums {
    Sloan = 1,
    Longway = 2
}

export class MuseumsEnum_class {
    public static enum = Museums;

    public static readonly enumByText: {[key: string]: number} = {
        'Sloan': 1,
        'Longway': 2
    }

    public static readonly enumByNumber: {[key: number]: string} = {
        1: 'Sloan',
        2: 'Longway'
    }
}